import React from 'react'
import {DETAILS_ROUTE} from '../../../../../../commons/constants/navigation'
import {ReservationState} from '../../../../../../commons/enums'
import {ChangeRsvp} from '../../change-rsvp'
import {LinkExpired} from '../../status-screens/link-expired'
import {OnlineConferencingStatus} from '../../status-screens/online-conferencing'
import {OrderCanceled} from '../../status-screens/order-canceled'
import {OrderExpired} from '../../status-screens/order-expired'
import {OrderFailed} from '../../status-screens/order-failed'
import {OrderSuccess} from '../../status-screens/order-success'
import {ThankYouMessages} from '../../status-screens/thank-you-messages'
import {StatusScreensEntryProps} from './interfaces'

const StatusScreensEntry = ({route, reservationState}: StatusScreensEntryProps) => {
  switch (route) {
    case DETAILS_ROUTE.TEMPLATE_ORDER:
      return <OrderSuccess />
    case DETAILS_ROUTE.ORDER:
      switch (reservationState) {
        case ReservationState.SUCCESS:
        case ReservationState.PENDING:
          return <OrderSuccess />
        case ReservationState.ERROR:
          return <OrderFailed />
        case ReservationState.CANCELED:
          return <OrderCanceled />
        case ReservationState.EXPIRED:
        default:
          return <OrderExpired />
      }
    case DETAILS_ROUTE.ONLINE_CONFERENCING:
      return <OnlineConferencingStatus />
    case DETAILS_ROUTE.LINK_EXPIRED:
    case DETAILS_ROUTE.NOT_FOUND:
      return <LinkExpired />
    case DETAILS_ROUTE.CHANGE_RSVP:
      return <ChangeRsvp />
    case DETAILS_ROUTE.THANK_YOU_MESSAGES:
      return <ThankYouMessages />
    default:
      return null
  }
}

export default StatusScreensEntry
